type CheckProps = {
  color?: string
}

const Check = ({ color = '#333333' }: CheckProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6001 8.37036L5.86676 12.7407L14.4001 4"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Check
